import {
  isCustomPatternLayer,
  isInteractableLayer,
  LayerType,
  type Layer,
  type LayerStyle,
} from '@pn/core/domain/layer';
import { getSelectedLayerId } from '@pn/core/domain/workspace';
import { mapboxLayerMapper } from '@pn/services/map/mapbox/mappers/mapboxLayerMapper';

const isSelectedExpr = ['==', ['feature-state', 'isSelected'], true] as const;

export function buildPrimaryLayers(params: {
  layer: Layer;
  sourceId: string;
  style: LayerStyle;
  selectionStyle: LayerStyle;
}): mapboxgl.AnyLayer[] {
  const { layer, sourceId, style, selectionStyle } = params;

  const primaryLayer: Layer = {
    ...layer,
    source: sourceId as any,
    style: {
      ...style,
      opacity: isCustomPatternLayer(layer)
        ? 0 // primary layer is just a collision layer for custom layers
        : isInteractableLayer(layer)
          ? ['case', isSelectedExpr, 0, style.opacity ?? 1]
          : (style.opacity ?? 1),
    },
  };

  const layers: mapboxgl.AnyLayer[] = [
    mapboxLayerMapper.toTargetLayer(primaryLayer) as mapboxgl.AnyLayer,
  ];

  if (isInteractableLayer(layer)) {
    const selectionPrimaryLayer: Layer = {
      ...layer,
      id: getSelectedLayerId(layer.id),
      source: sourceId as any,
      style: {
        ...selectionStyle,
        opacity: ['case', isSelectedExpr, 1, 0],
        ...(layer.type === LayerType.Icon || layer.type === LayerType.Text
          ? { ignorePlacement: true }
          : {}),
      },
    };

    layers.push(
      mapboxLayerMapper.toTargetLayer(
        selectionPrimaryLayer
      ) as mapboxgl.AnyLayer
    );
  }

  return layers;
}
